import { useEffect, useMemo } from 'react';
import io from 'socket.io-client';
import config from '../../config';
import { useApplicationContext } from '../../modules/context/ApplicationContext/ApplicationContext';
import { StorageEnum } from '../../modules/context/storage';
import { BuildSocketParams } from './types/user-activity.types';
import { dailyUserActivityRepository } from './user-activity.repository';

const buildSocket = ({ brandId, userId, sessionId }: BuildSocketParams) => {
  return io(`${config.websocketUrl}/user-activity`, {
    path: '/ws',
    transports: ['websocket'],
    query: {
      brandId,
      userId,
      sessionId,
    },
  });
};

export const UserActivity = () => {
  const { state, team } = useApplicationContext();

  const localUser = useMemo(
    () => (state?.user && localStorage.user ? JSON.parse(localStorage.user) : undefined),
    [state?.user],
  );

  useEffect(() => {
    if (team?.id) {
      dailyUserActivityRepository();
    }
  }, [team?.id]);

  useEffect(() => {
    if (team?.userId && team.brand?.id && localUser) {
      const socket = buildSocket({
        userId: team.userId,
        brandId: team.brand?.id,
        sessionId: localUser[StorageEnum.SESSION_ID],
      });
      return () => {
        socket.disconnect();
      };
    }
  }, [team?.userId, team?.brand?.id, localUser?.[StorageEnum.SESSION_ID]]);

  return null;
};
